import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

interface MemorialEntry {
  name: string;
  date: string;
  description: string;
}

interface MemorialPageProps {
  content: MemorialEntry[];
}

const MemorialPage: React.FC<MemorialPageProps> = ({ content }) => {
  return (
    <div className="flex flex-col items-center">
      <h2 className="heading-secondary mb-8">לעילוי נשמת</h2>
      
      <div className="grid grid-cols-1 gap-6 w-full max-w-4xl">
        {content.map((entry, index) => (
          <Card key={index} className="border-2 border-synagogue-blue/30">
            <CardHeader className="pb-2">
              <h3 className="text-2xl font-frank text-synagogue-blue">{entry.name}</h3>
            </CardHeader>
            <CardContent>
              <p className="text-lg mb-2">{entry.date}</p>
              <p className="text-gray-700">{entry.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
      
      {content.length === 0 && (
        <p className="text-xl text-gray-500">אין רשומות להצגה</p>
      )}
    </div>
  );
};

export default MemorialPage;
